import React from 'react';

// Import all 30 logo images
import logo1 from '../../images/partner_1.png';
import logo2 from '../../images/partner_2.png';
import logo3 from '../../images/partner_3.png';
import logo4 from '../../images/partner_4.png';
import logo5 from '../../images/partner_5.png';
import logo6 from '../../images/partner_6.png';
import logo7 from '../../images/partner_7.png';
import logo8 from '../../images/partner_8.png';
import logo9 from '../../images/partner_9.jpeg';
import logo10 from '../../images/partner_10.jpeg';
import logo11 from '../../images/partner_11.png';
import logo12 from '../../images/partner_12.png';
import logo13 from '../../images/partner_13.png';
import logo14 from '../../images/partner_14.jpeg';
import logo15 from '../../images/partner_15.png';
import logo16 from '../../images/partner_16.png';
import logo17 from '../../images/partner_17.png';
import logo18 from '../../images/partner_18.jpeg';
import logo19 from '../../images/partner_19.png';
import logo20 from '../../images/partner_20.png';
import logo21 from '../../images/partner_21.jpeg';
import logo22 from '../../images/partner_22.png';
import logo23 from '../../images/partner_23.png';
import logo24 from '../../images/partner_24.png';
import logo25 from '../../images/partner_25.jpeg';
import logo26 from '../../images/partner_26.jpeg';
import logo27 from '../../images/partner_27.jpeg';
import logo28 from '../../images/partner_28.png';
import logo29 from '../../images/partner_29.png';
import logo30 from '../../images/partner_30.png';

const BrandMarquee = () => {
  // Array of 30 brand logo images with imported variables
  const brandLogos = [
    { id: 1, src: logo1, alt: 'Brand 1', name: 'Brand 1' },
    { id: 2, src: logo2, alt: 'Brand 2', name: 'Brand 2' },
    { id: 3, src: logo3, alt: 'Brand 3', name: 'Brand 3' },
    { id: 4, src: logo4, alt: 'Brand 4', name: 'Brand 4' },
    { id: 5, src: logo5, alt: 'Brand 5', name: 'Brand 5' },
    { id: 6, src: logo6, alt: 'Brand 6', name: 'Brand 6' },
    { id: 7, src: logo7, alt: 'Brand 7', name: 'Brand 7' },
    { id: 8, src: logo8, alt: 'Brand 8', name: 'Brand 8' },
    { id: 9, src: logo9, alt: 'Brand 9', name: 'Brand 9' },
    { id: 10, src: logo10, alt: 'Brand 10', name: 'Brand 10' },
    { id: 11, src: logo11, alt: 'Brand 11', name: 'Brand 11' },
    { id: 12, src: logo12, alt: 'Brand 12', name: 'Brand 12' },
    { id: 13, src: logo13, alt: 'Brand 13', name: 'Brand 13' },
    { id: 14, src: logo14, alt: 'Brand 14', name: 'Brand 14' },
    { id: 15, src: logo15, alt: 'Brand 15', name: 'Brand 15' },
    { id: 16, src: logo16, alt: 'Brand 16', name: 'Brand 16' },
    { id: 17, src: logo17, alt: 'Brand 17', name: 'Brand 17' },
    { id: 18, src: logo18, alt: 'Brand 18', name: 'Brand 18' },
    { id: 19, src: logo19, alt: 'Brand 19', name: 'Brand 19' },
    { id: 20, src: logo20, alt: 'Brand 20', name: 'Brand 20' },
    { id: 21, src: logo21, alt: 'Brand 21', name: 'Brand 21' },
    { id: 22, src: logo22, alt: 'Brand 22', name: 'Brand 22' },
    { id: 23, src: logo23, alt: 'Brand 23', name: 'Brand 23' },
    { id: 24, src: logo24, alt: 'Brand 24', name: 'Brand 24' },
    { id: 25, src: logo25, alt: 'Brand 25', name: 'Brand 25' },
    { id: 26, src: logo26, alt: 'Brand 26', name: 'Brand 26' },
    { id: 27, src: logo27, alt: 'Brand 27', name: 'Brand 27' },
    { id: 28, src: logo28, alt: 'Brand 28', name: 'Brand 28' },
    { id: 29, src: logo29, alt: 'Brand 29', name: 'Brand 29' },
    { id: 30, src: logo30, alt: 'Brand 30', name: 'Brand 30' }
  ];

  // Duplicate the array to create seamless infinite loop
  const duplicatedLogos = [...brandLogos, ...brandLogos];

  // Inline styles for the animation
  const marqueeStyle = {
    display: 'flex',
    animation: 'marquee 40s linear infinite',
    width: 'fit-content'
  };

  const marqueeItemStyle = {
    flex: '0 0 auto',
    padding: '0 20px'
  };

  const logoWrapperStyle = {
    width: '200px',
    height: '120px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    
    transition: 'all 0.3s ease',

  };

  const logoStyle = {
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    filter: 'grayscale(10%)',
    opacity: '0.8',
    transition: 'all 0.3s ease'
  };

  // Add keyframes to document
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    @keyframes marquee {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
    
    .marquee-container {
      width: 100%;
      overflow: hidden;
      position: relative;
    }
    
    .marquee-container:hover .marquee-track {
      animation-play-state: paused;
    }
    
    .marquee-track:hover .brand-logo-wrapper {
      transform: translateY(-1px);
    
    }
    
    .brand-logo-wrapper:hover .brand-logo {
      filter: grayscale(0%) !important;
      opacity: 1 !important;
      transform: scale(1.05);
    }
    
    // .gradient-overlay-left {
    //   position: absolute;
    //   left: 0;
    //   top: 0;
    //   width: 150px;
    //   height: 100%;
    //   background: linear-gradient(90deg, #ffffff, transparent);
    //   z-index: 2;
    //   pointer-events: none;
    // }
    
    // .gradient-overlay-right {
    //   position: absolute;
    //   right: 0;
    //   top: 0;
    //   width: 150px;
    //   height: 100%;
    //   z-index: 2;
    //   pointer-events: none;
    // }
    
    @media (max-width: 768px) {
      .brand-logo-wrapper {
        width: 120px !important;
        height: 60px !important;
        padding: 10px !important;
      }
      
      .gradient-overlay-left,
      .gradient-overlay-right {
        width: 50px !important;
      }
    }
    
    @media (max-width: 576px) {
      .brand-logo-wrapper {
        width: 100px !important;
        height: 50px !important;
      }
    }
  `;
  document.head.appendChild(styleElement);

  return (
    <section className="py-5" style={{ 
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      overflow: 'hidden',
      position: 'relative'
    }}>
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12 text-center">
            <h2 className="display-5 fw-bold  mb-3" style={{
              position: 'relative',
              display: 'inline-block',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              color:'#2c2c2c',
             
        
            }}>
              Trusted By Industry Leaders
              <span style={{
                content: '""',
                position: 'absolute',
                bottom: '-10px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '200px',
                height: '3px',
                background: 'linear-gradient(90deg, #a20b86, #00e279)',
                borderRadius: '3px'
              }}></span>
            </h2>
            <p className="text-secondary" style={{ color: '#a20b86' }}>
              We've had the privilege of working with amazing brands worldwide
            </p>
          </div>
        </div>
        
        <div className="marquee-container position-relative">
          {/* Gradient Overlays */}
          <div className="gradient-overlay-left"></div>
          <div className="gradient-overlay-right"></div>
          
          {/* Marquee Track */}
          <div className="marquee-track" style={marqueeStyle}>
            {duplicatedLogos.map((logo, index) => (
              <div key={`${logo.id}-${index}`} style={marqueeItemStyle}>
                <div 
                  className="brand-logo-wrapper shadow-sm"
                  style={logoWrapperStyle}
                >
                  <img 
                    src={logo.src} 
                    alt={logo.alt}
                    className="brand-logo"
                    style={logoStyle}
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

     
    </section>
  );
};

export default BrandMarquee;